import Stack from "@mui/material/Stack";
import MainCard from "../Layouts/MainCard";
import { CardTitle } from "../theme/texts";
import { Theme } from "../../data/style/Theme";
import { SpacedRow } from "../../data/style/Style";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";

const BiometricsPanel = () => {
  const { profile, settings } = useAuth();
  const { mobileDevice } = useScreenSize();
  let biometrics = profile.biometrics;

  return (
    <MainCard>
      <CardTitle
        subTitle={"Health"}
        mainTitle={"Biometrics"}
        isMobile={mobileDevice}
      />
      <Stack gap={2}>
        {[
          {
            label: "Weight",
            value: biometrics.weight,
            extra: (
              <>
                This month:{" "}
                {biometrics.result === "None" ? (
                  "No change"
                ) : (
                  <>
                    {biometrics.result === "gain" ? "+" : "-"}{" "}
                    {settings.weight === 0
                      ? biometrics.month_difference + " kg"
                      : biometrics.month_difference_lb + " lb"}
                  </>
                )}
              </>
            ),
            extraColor: Theme.palette.muted,
          },
          { label: "Height", value: profile.height, extra: null },
        ].map((item, i) => (
          <div
            key={i}
            style={{
              padding: "11px 14px",
              borderRadius: 12,
              background: Theme.palette.card,
              border: `1px solid ${Theme.palette.border}`,
            }}
          >
            <div
              style={{
                fontFamily: "DM Sans, sans-serif",
                fontSize: 11,
                color: Theme.palette.muted,
                marginBottom: 3,
              }}
            >
              {item.label}
            </div>
            <div
              style={{
                fontFamily: "Oswald, sans-serif",
                fontWeight: 700,
                fontSize: 20,
                color: Theme.palette.orange,
              }}
            >
              {item.value}
            </div>
            {item.extra && (
              <div
                style={{
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: 11,
                  color: item.extraColor,
                  marginTop: 2,
                }}
              >
                {item.extra}
              </div>
            )}
          </div>
        ))}
        {/* BMI */}
        <div
          style={{
            padding: "11px 14px",
            borderRadius: 12,
            background: Theme.palette.card,
            border: `1px solid ${Theme.palette.border}`,
          }}
        >
          <SpacedRow
            sx={{
              marginBottom: "6px",
            }}
          >
            <div
              style={{
                fontFamily: "DM Sans, sans-serif",
                fontSize: 11,
                color: Theme.palette.muted,
              }}
            >
              BMI
            </div>
            <div
              style={{
                fontFamily: "Oswald, sans-serif",
                fontWeight: 700,
                fontSize: 14,
                color:
                  biometrics.bmi >= 30
                    ? Theme.palette.down
                    : biometrics.bmi >= 25
                      ? Theme.palette.gold
                      : biometrics.bmi >= 18.5
                        ? Theme.palette.up
                        : Theme.palette.down,
              }}
            >
              {biometrics.bmi}
            </div>
          </SpacedRow>
          <div
            style={{
              height: 5,
              borderRadius: 99,
              background: Theme.palette.border,
              overflow: "hidden",
              marginBottom: 5,
            }}
          >
            <div
              style={{
                height: "100%",
                width: `100%`,
                borderRadius: 99,
                background: `linear-gradient(90deg,${Theme.palette.down}, ${Theme.palette.up}, #facc15, ${Theme.palette.down})`,
              }}
            />
            <div
              style={{
                height: "15px",
                width: "15px",
                borderRadius: "50%",
                background: "white",
                position: "relative",
                marginTop: "-10px",
                left:
                  biometrics.bmi >= 30
                    ? "95%"
                    : biometrics.bmi >= 25
                      ? "70%"
                      : biometrics.bmi >= 18.5
                        ? "30%"
                        : "0%",
              }}
            />
          </div>
          <div
            style={{
              fontFamily: "DM Sans, sans-serif",
              fontSize: 10,
              color: Theme.palette.muted,
            }}
          >
            Normal:{" "}
            <span style={{ color: Theme.palette.up, fontWeight: 700 }}>
              18.5 – 25
            </span>
          </div>
        </div>
      </Stack>
    </MainCard>
  );
};

export default BiometricsPanel;
